window.acceleratedDataQueue = window.acceleratedDataQueue || [];
window.acceleratedDataQueue.push({
  ACC_TDT_Product_08: {
    // Cached references and constants
    var: {
      OFFSET: 100,
      DEBOUNCE_DELAY: 150,
    },

    // Scroll to tab with boundary checks
    scrollToTab(tabsContainer, tab, offset = this.var.OFFSET) {
      if (!tabsContainer?.scrollTo || !tab?.offsetLeft) return;

      const maxScroll = tabsContainer.scrollWidth - tabsContainer.clientWidth;
      const targetPosition = Math.max(0, Math.min(tab.offsetLeft - offset, maxScroll));

      tabsContainer.scrollTo({
        left: targetPosition,
        behavior: "smooth",
      });
    },

    // Efficient drag-to-tab initialization
    initSwiperDragToTab(sliderSelector, tabsSelector) {
      const slider = document.querySelector(sliderSelector);
      const tabs = document.querySelectorAll(tabsSelector);
      if (!slider || !tabs.length || !window.Flickity) return;

      // Single Flickity instance management
      const flkty = Flickity.data(slider);

      // Handle thumbnail scrolling when slide changes
      flkty.on("settle", (index) => {
        const tabsScroller = document.querySelector(".product-section .product__thumbs--scroller");
        const selectedSlide = slider.querySelector(".product-main-slide.is-selected");

        const dataIndex = selectedSlide.getAttribute("data-index");
        const activeThumb = tabsScroller.querySelector(`.product__thumb-item[data-index="${dataIndex}"]`);

        // Scroll the thumbnail into view
        if (activeThumb) {
          if (index === 0) {
            // If wrapAround occurred (last to first slide), force scroll
            activeThumb.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
          } else {
            this.scrollToTab(tabsScroller, activeThumb);
          }
        }
      });
    },
    // Optimized slider updates
    updateProductSlider() {
      const slider = document.querySelector(".product__main-photos .product-slideshow");
      if (!slider || window.innerWidth > 768 || !window.Flickity) return;

      const flkty = Flickity.data(slider);
      if (!flkty) return;

      Object.assign(flkty.options, { groupCells: 1, draggable: true });
      flkty.resize();
    },

    // Optimized initialization sequence
    init() {
      this.runAt(".product-section .product__thumbs--scroller", ([thumbScroller]) => {
        thumbScroller.querySelector(".flickity-slider")?.style.removeProperty("transform");
        this.initializeTabScrolling(".product-section .product__thumbs--scroller", ".product-section .product__thumb-item");
      });

      this.runAt(".product__main-photos .product-slideshow.flickity-enabled", () => {
        this.updateProductSlider();
        this.initSwiperDragToTab(".product__main-photos .product-slideshow", ".product-section .product__thumb-item");
      });
    },
  },
});